import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { scrollToTopImmediately } from './scroll-to-top';

export function RouteScrollManager() {
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  useLayoutEffect(() => {
    if (previousPathname.current === pathname) {
      return;
    }

    previousPathname.current = pathname;
    scrollToTopImmediately();
    const frameId = window.requestAnimationFrame(scrollToTopImmediately);

    return () => window.cancelAnimationFrame(frameId);
  }, [pathname]);

  return null;
}
